/**
 * Created by mykurisu on 2018/5/14.
 */
import React from 'react'
import {connect} from 'react-redux'


class SVIPBar extends React.Component {
    /*
    * 超级会员位于详情页的Bar
    * isCoupon是否有优惠券Bar
    * content channel字段
    * @mykurisu
    * */

    handleBarClick() {
        // if (this.props.role.is_member) {
        //     this.props.dispatch({
        //         type: 'PAY_CHANNEL_MEMBER',
        //         payload: {
        //             params: {
        //                 product: 'pay_channel_member',
        //                 channel_id: this.props.content.id,
        //             },
        //             success: () => {
        //                 this.props.dispatch({
        //                     type: 'PAY_SUCCESS'
        //                 })
        //                 window._wk_toast && window._wk_toast.show('已添加到__br我的微课', 'success', 2000)
        //                 if (this.props.type === 'lecture') {
        //                     this.props.dispatch({
        //                         type: 'LECTURE_CHANGE_CHANNEL_SVIP_SUCCESS'
        //                     })
        //                 } else {
        //                     this.props.dispatch({
        //                         type: 'CHANNEL_SVIP_SUCCESS'
        //                     })
        //                 }
        //             }
        //         }
        //     })
        // } else {
        //     window.location = '/supervip'
        // }
        window.location = '/supervip'
    }

    render() {
        const isCoupon = this.props.isCoupon
        return (
            <div className="svip__couponbar__shownbar" style={{marginTop: isCoupon ? '-10px' : '0'}} onClick={() => this.handleBarClick()}>
                <div className="lecture__shownbar__left">
                    <img src="https://static-cos.lycheer.net/picture/6163375_4a60f45559d85b3b6ae590a9b53517c6.jpg" alt=""/> 会员免费听
                </div>
                <div className="lecture__shownbar__right"></div>
            </div>
        )
    }
}

export default connect(state => ({}))(SVIPBar)



// WEBPACK FOOTER //
// ./src/components/details/SVIPBar.js